import { clientApi } from '../../configuration';
import { getPermissionsHook } from '../../utils';

type UserJurySessionPermissionCodes =
  | 'CAN_ARBITRATE_JURY_SESSION_ASSESSMENT'
  | 'CAN_CREATE_JURY_SESSION_ASSESSMENT_RESULT'
  | 'CAN_DELETE_JURY_SESSION'
  | 'CAN_CREATE_JURY_SESSION_ASSESSMENT'
  | 'CAN_DELETE_ASSESSMENT'
  | 'CAN_DOWNLOAD_STUDENT_CREDENTIAL'
  | 'CAN_JURY_SESSION_SIGN_PV'
  | 'CAN_CREATE_STUDENT_CREDENTIAL'
  | 'CAN_UPDATE_STUDENT_CREDENTIAL';

const useGetUserJurySessionPermissions = getPermissionsHook<
  UserJurySessionPermissionCodes,
  {
    userId: number;
    jurySessionId: number;
  }
>({
  entityName: 'userJurySessionPermissions',
  fetch: ({ userId, jurySessionId }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .jurySessions.id(jurySessionId)
      .permissions.find(),
});

export default useGetUserJurySessionPermissions;
